const exhibition = {
    getlist: 'exhibition/getlist-by-admin',
    add: 'exhibition/add',
    update: 'exhibition/update',
    remove: 'exhibition/remove',
    get: 'exhibition/get-by-admin',
    getall: 'exhibition/getall',
}
export default exhibition
